<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  body{
    padding: 0;
    margin: 0;
    font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
  }
  #app{
    width: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
  }
  a {
    text-decoration: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-user-drag: none;
  }

  button{
    margin: 0;
    padding: 0;
    border: 1px solid transparent;
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue